import React, { useEffect, useState } from "react";
import { AppGlobals } from "./AppGlobals";
import Logout from "./Logout";
import HomeTiles from "./HomeTiles";
import { ZedXMainMenu } from "./components/ZedXMainMenu";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { DataContext } from "./components/DataContext";
import { OrbUserContext } from "./components/OrbUserContext";
import { useUserContext } from "./components/useUserContext";
import { useDataContext } from "./components/useDataContext";
import { useApi } from "./components/useApi";
import { IOrbProps } from "./App";
import { HashRouter, Route, Switch } from "react-router-dom";
import { ChangePassword } from "./components/account/ChangePassword";
import { IEntity } from "./types";
import { CrLoadingOverlay } from "./components/cr/CrLoadingOverlay";
import { TopBanner } from "./TopBanner";
import { MenuToggle } from "./components/MenuToggle";
import { buildZedXMainAppBreadcrumb } from "./breadcrumbs";
import { useHistory, useLocation } from "react-router-dom";

interface ZedXMainAppProps extends IOrbProps {
    onLogout?: () => void;
    authType: string;
}

export const ZedXMainApp = (props: ZedXMainAppProps): React.ReactElement => {

    const history = useHistory();
    const location = useLocation();

    const [isNavigationVisible, setNavigationVisible] = useState(false);
    const toggleNavigation = () => setNavigationVisible(!isNavigationVisible);

    const { dataServices, errorHandling } = props;
    const apiConnected = useApi(dataServices);
    const uc = useUserContext(apiConnected, dataServices, errorHandling);
    const ld = useDataContext(apiConnected, dataServices, errorHandling);
    const [lastFiveApps, setLastFiveApps] = useState<IEntity[]>(null);

    useEffect(() => {
        const fetchLastFive = async () => {
            const lastFive: IEntity[] = await dataServices.userAppLaunchLogService.getLastFive();
            setLastFiveApps(lastFive);
        };
        fetchLastFive();
    }, []);

    const breadcrumbItems = buildZedXMainAppBreadcrumb({
        customerTitle: AppGlobals.CustomerTitle,
        location,
        history
    });

    return (
        <React.Fragment>
            <ErrorBoundary>
                <DataContext.Provider value={ld}>
                    <OrbUserContext.Provider value={uc}>

                        <div className="main">
                            <div className="container">

                                {/* LEFT NAVIGATION */}
                                <div className={`navigation ${isNavigationVisible ? 'show' : ''}`}>
                                    {lastFiveApps === null
                                        ? <CrLoadingOverlay opaque={true} isLoading={true} />
                                        : <ZedXMainMenu
                                            authType={props.authType}
                                            onLogout={props.onLogout}
                                            onLinkClicked={toggleNavigation}
                                            menuData={props.menuData}
                                            lastFiveApps={lastFiveApps}
                                        />
                                    }
                                </div>

                                {/* BACKDROP */}
                                <div
                                    className={`nav-backdrop ${isNavigationVisible ? 'show' : ''}`}
                                    onClick={toggleNavigation}
                                    aria-hidden={!isNavigationVisible}
                                />

                                {/* RIGHT CONTENT AREA */}
                                <div className="right-area">
                                    <div className="top-banner">
                                        <MenuToggle onToggleNavigation={toggleNavigation} />
                                        <TopBanner
                                            customerTitle={AppGlobals.CustomerTitle}
                                            userName={AppGlobals.UserTitle}
                                            breadcrumbItems={breadcrumbItems}
                                            onLogout={props.onLogout}
                                        />
                                    </div>

                                    <div className="content">
                                        <HashRouter>
                                            <Switch>
                                                <Route exact path="/">
                                                    <HomeTiles menuData={props.menuData} />
                                                </Route>
                                                <Route path="/account/change-password">
                                                    <ChangePassword />
                                                </Route>
                                            </Switch>
                                        </HashRouter>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </OrbUserContext.Provider>
                </DataContext.Provider>
            </ErrorBoundary>
        </React.Fragment>
    );
};
